<template>
  <div class="grid-view">
    <div class="main-content">
      <div class="section grid-wrapper">
        <cargo-ag-grid
          :config-module="configModule"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          :config-module="configModule"
          :total="rowData.length"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          layout="total, slot"
          @pagination="toQuery()"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { ClearingUtils } from '@/class/cargo/model/utils/ClearingUtils'

export default {
  name: 'BillActualAmountGrid',
  components: {},
  props: {
    configModule: { type: String, default: '410015204' },
    gridOptions: { type: Object, default: () => {} },
    filter: { type: Object, default: () => {} },
    clearState: { type: Number, default: 0 },
    rowData: { type: Array, default: () => [] }
  },
  data() {
    return {
      gridParams: {},
      columnDefs: [
        {
          headerName: ' ', maxWidth: 40, checkboxSelection: true, pinned: 'left',
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        { headerName: this.$t('CargoMsg.Cargo_SettleAccountsTo'), field: 'accountId', colId: 'accountId', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_Currency'), field: 'currency', colId: 'currency', width: 200 },
        { headerName: this.$t('CargoMsg.Cargo_WriteOffAmount'), field: 'amount', colId: 'amount', width: 200,
          valueFormatter: (params) => {
            return ClearingUtils.numberPrecision(params.value)
          } },
        { headerName: this.$t('CargoMsg.Cargo_WriteOffPerson'), field: 'verificationBy', colId: 'verificationBy', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          } },
        { headerName: this.$t('CargoMsg.Cargo_WriteOffDate'), field: 'verificationDate', colId: 'verificationDate', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('CargoMsg.Cargo_PayReceiveDate'), field: 'payReceiveDate', colId: 'payReceiveDate', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('CargoMsg.Cargo_OurBank'), field: 'ourBank', colId: 'ourBank', width: 200,
          valueFormatter: (params) => {
            return ClearingUtils.getPaymentType(params.value)
          } },
        { headerName: this.$t('CargoMsg.Cargo_VoucherNo'), field: 'bankWaterNo', colId: 'bankWaterNo', width: 200 },
        { headerName: this.$t('CargoMsg.Cargo_SettlementAgent'), field: 'settlementAgentId', colId: 'settlementAgentId', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_SendConfirmationStatus'), field: 'SendConfirmationStatus', colId: 'SendConfirmationStatus', width: 200,
          valueFormatter: (params) => {
            return this.confirmStatesLabFunc(params.data)
          } },
        {
          headerName: this.$t('CargoMsg.Cargo_BusinessNo'), colId: 'jobNo', field: 'jobNo'
        },
        { headerName: this.$t('CargoMsg.Cargo_ItemNo'), field: 'poNo', colId: 'poNo', width: 200 }
      ]
    }
  },
  computed: {
    showMainList() {
      return !this.showDetail
    }
  },
  methods: {
    confirmStatesLabFunc(act) {
      let isConfirm = true
      for (const clear of act.clearHistory) {
        if (clear.confirmState !== 2) {
          isConfirm = false
          break
        }
      }
      if (isConfirm) {
        return this.$t('CargoMsg.Cargo_Confirmed')
      }
      if (this.isAllSend(act.clearHistory)) {
        return this.$t('CargoMsg.Cargo_Sent')
      }
      if (this.clearState < 1) {
        if (this.isSectionSend(act.clearHistory)) {
          return this.$t('CargoMsg.Cargo_SendPartial')
        }
      }
      if (this.clearState === 1) {
        if (this.isSectionSend(act.clearHistory)) {
          return this.$t('CargoMsg.Cargo_SendPartial')
        }
        if (this.isSectionConfirm(act.clearHistory)) {
          return this.$t('CargoMsg.Cargo_PartialConfirmation')
        }
      } else {
        if (this.isSectionConfirm(act.clearHistory)) {
          return this.$t('CargoMsg.Cargo_PartialConfirmation')
        }
      }
      return this.$t('CargoMsg.Cargo_NotSent')
    },
    isSectionConfirm(clearHistory) {
      const state = []
      for (const clear of clearHistory) {
        state.push(clear.confirmState)
      }
      if (state.includes(1) && state.includes(2)) {
        return true
      }
      return false
    },
    isAllSend(clearHistory) {
      for (const clear of clearHistory) {
        if (clear.confirmState !== 1) {
          return false
        }
      }
      return true
    },
    isSectionSend(clearHistory) {
      const state = []
      for (const clear in clearHistory) {
        state.push(clear.confirmState)
      }
      if (state.includes(0) && state.includes(1) && state.includes(2)) {
        return true
      }
      if (state.includes(0) && state.includes(1)) {
        return true
      }
      return false
    },
    toQuery() {
    }
  }
}
</script>
<style lang="scss">
</style>
